export const FEATURE_GATING_ACTIONS = {
  SET_LOADING: "SET_LOADING",
  SET_FEATURES: "SET_FEATURES",
  ADD_FEATURE: "ADD_FEATURE",
  UPDATE_FEATURE: "UPDATE_FEATURE",
  DELETE_FEATURE: "DELETE_FEATURE",
  SET_ERROR: "SET_ERROR",
  CLEAR_ERROR: "CLEAR_ERROR",
  SET_SELECTED_FEATURE: "SET_SELECTED_FEATURE",
  RESET_STATE: "RESET_STATE",
};

const initialState = {
  features: [],
  loading: false,
  error: null,
  selectedFeature: null,
};

export const featureGatingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FEATURE_GATING_ACTIONS.SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    case FEATURE_GATING_ACTIONS.SET_FEATURES:
      return {
        ...state,
        features: action.payload,
        loading: false,
        error: null,
      };

    case FEATURE_GATING_ACTIONS.ADD_FEATURE:
      return {
        ...state,
        features: [...state.features, action.payload],
        loading: false,
        error: null,
      };

    case FEATURE_GATING_ACTIONS.UPDATE_FEATURE:
      return {
        ...state,
        features: state.features.map(feature =>
          feature.featureId === action.payload.featureId ? action.payload : feature
        ),
        loading: false,
        error: null,
      };

    case FEATURE_GATING_ACTIONS.DELETE_FEATURE:
      return {
        ...state,
        features: state.features.filter(feature => feature.featureId !== action.payload),
        loading: false,
        error: null,
      };

    case FEATURE_GATING_ACTIONS.SET_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case FEATURE_GATING_ACTIONS.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    case FEATURE_GATING_ACTIONS.SET_SELECTED_FEATURE:
      return {
        ...state,
        selectedFeature: action.payload,
      };

    case FEATURE_GATING_ACTIONS.RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default featureGatingReducer;
